import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'firstLetterUpper'
})

// TODO refactor уже имеется функция firstToUpperCase в HelperService
export class FirstletterupperPipe implements PipeTransform {
  transform(value: string, args?: any[]): string {
    return value?(value[0].toUpperCase()+value.slice(1)):'';
  }

}
